import errors from "./fr/global.errors";
import paymentStatus from "./fr/pages.paymentStatus";

const french = {
  global: {
    errors,
  },
  pages: {
    paymentStatus,
  },
};

export default french;
